/**
 * x-file-manager: hidden `file_status` のワイヤ値（文字列の 0–3）。
 * PHP: App\Enums\FileManagerFileStatus と同一値を保つこと。
 *
 * @readonly
 * @enum {string}
 */
export const FileManagerFileStatus = Object.freeze({
    None: '0',
    NewUpload: '1',
    Replace: '2',
    Delete: '3',
});
